import React from "react"

const SectionChallenges = () => (
  <section className="chal-sec">
    <div className="wrap">
      <h2>What makes CJR-X hard</h2>
      <div className="chal">
        <div className="ch">
          <div className="ch-ic">
            <svg
              viewBox="0 0 32 32"
              aria-hidden="true"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.3"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="5" y="7" width="22" height="20" rx="2" />
              <path d="M5 13h22M11 4v6M21 4v6" />
              <path d="M12 18l8 6M20 18l-8 6" />
            </svg>
          </div>
          <b>No practice year</b>
          <span>Two-sided risk starts in 2028.</span>
        </div>
        <div className="ch">
          <div className="ch-ic">
            <svg
              viewBox="0 0 32 32"
              aria-hidden="true"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.3"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M16 28s9-8.6 9-15a9 9 0 0 0-18 0c0 6.4 9 15 9 15z" />
              <circle cx="16" cy="13" r="3.2" />
            </svg>
          </div>
          <b>Your region sets the bar</b>
          <span>Targets come from your census division.</span>
        </div>
        <div className="ch">
          <div className="ch-ic">
            <svg
              viewBox="0 0 32 32"
              aria-hidden="true"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.3"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M5 15 16 6l11 9" />
              <path d="M8 13v13h16V13" />
              <path d="M14 26v-7h4v7" />
            </svg>
          </div>
          <b>Post-acute drives cost</b>
          <span>The main source of savings in the original CJR.</span>
        </div>
        <div className="ch">
          <div className="ch-ic">
            <svg
              viewBox="0 0 32 32"
              aria-hidden="true"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.3"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M8 4h11l5 5v19H8z" />
              <path d="M12 14h8M12 18h8M12 22h5" />
            </svg>
          </div>
          <b>Documentation counts</b>
          <span>Risk adjustment uses the 180 days before surgery.</span>
        </div>
        <div className="ch">
          <div className="ch-ic">
            <svg
              viewBox="0 0 32 32"
              aria-hidden="true"
              fill="none"
              stroke="currentColor"
              strokeWidth="2.3"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M16 4l3.6 7.4 8.1 1.1-5.9 5.7 1.4 8.1L16 22.4l-7.2 3.9 1.4-8.1-5.9-5.7 8.1-1.1z" />
            </svg>
          </div>
          <b>Quality comes first</b>
          <span>A minimum score is required for any payment.</span>
        </div>
      </div>
    </div>
  </section>
)

export default SectionChallenges
